import React from 'react'

import {
  Container,
  Stepper,
  Step,
  StepLabel,
  Box,
  Typography,
  useTheme,
} from '@material-ui/core'

import {
  ShoppingCartOutlined,
  FingerprintOutlined,
  PersonOutlineOutlined,
  DescriptionOutlined,
} from '@material-ui/icons'

import Steps from './../components/Steps'
import useWindowSize from 'hooks/useWindowSize'
import useSubscribe from 'hooks/useSubscribe'

const CustomStepLabel = ({ step, icon: Icon, children }) => {
  const theme = useTheme()
  const windowSize = useWindowSize()
  const subscribe = useSubscribe()

  const iconProps = React.useMemo(
    () =>
      step <= subscribe.activeStep
        ? { color: 'secondary' }
        : { color: 'disabled' },
    [step, subscribe.activeStep],
  )

  const textProps = React.useMemo(
    () =>
      step <= subscribe.activeStep
        ? {
            color: 'primary',
            style: { fontWeight: theme.typography.fontWeightMedium },
          }
        : {},
    [step, subscribe.activeStep, theme.typography.fontWeightMedium],
  )

  if (!windowSize.isDesktop) {
    return <Icon {...iconProps} />
  }

  return (
    <StepLabel icon={<Icon {...iconProps} />}>
      <Typography variant="inherit" {...textProps}>
        {children}
      </Typography>
    </StepLabel>
  )
}

const SubscribeCheckout = () => {
  const subscribe = useSubscribe()

  return (
    <Container maxWidth="md">
      <Stepper activeStep={subscribe.activeStep}>
        <Step>
          <CustomStepLabel step={0} icon={ShoppingCartOutlined}>
            Carrinho
          </CustomStepLabel>
        </Step>
        <Step>
          <CustomStepLabel step={1} icon={FingerprintOutlined}>
            Identificação
          </CustomStepLabel>
        </Step>
        <Step>
          <CustomStepLabel step={2} icon={PersonOutlineOutlined}>
            Contratante
          </CustomStepLabel>
        </Step>
        <Step>
          <CustomStepLabel step={3} icon={DescriptionOutlined}>
            Contratação
          </CustomStepLabel>
        </Step>
      </Stepper>

      <Box mb={8}>
        {subscribe.activeStep === 0 && <Steps.Cart />}
        {subscribe.activeStep === 1 && <Steps.Identification />}
        {subscribe.activeStep === 2 && <Steps.Contractor />}
        {subscribe.activeStep === 3 && <Steps.Contract />}
      </Box>
    </Container>
  )
}

export default SubscribeCheckout
